import React, { useEffect, useState } from "react";
import { useNotificationContext } from "../../../common/NotificationContext";
import { useLoading } from "../../../common/LoadingContext";
import {
  BrandListingService,
  BrandListingSearchService,
  categoryListingService,
  BrickListingWithOrWithoutFamilyId,
  FamilyListingService,
  AllBrandListingService,
} from "../../../services/MasterDataManagementService";
import BrandList from "./BrandList";
import useGlobalState from "../../../Context";

const Brand = () => {
  const [brandList, setBrandList] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [categoryList, setCategoryList] = useState([]);
  const [productFamilyList, setProductFamilyList] = useState([]);
  const [brickList, setBrickList] = useState([]);
  const [allBrands, setAllBrands] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;

  useEffect(() => {
    fetchBrandsDetails("brandName", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchBrandsDetails = async (sortBy, isAsc,searchValue,paginationObject) => {
    try {
      setLoading(true);
      const requestBody = {
       
        pageNumber: paginationObject?.pageNumber?? 0,
        pageSize:  paginationObject?.pageSize??10,
        filterSearch: searchValue ? searchValue :null,
        sortDirection: isAsc ? "DESC" : "ASC",
        sortBy: sortBy,
        active: loginUserType === "Main Admin" ? 2 : 0,
      };
      const brandListingResponse = await BrandListingService(requestBody);

      if (brandListingResponse.statusCode === 6) {
        if (brandListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setBrandList(brandListingResponse.data.content);
        setTotalElements(brandListingResponse.data.totalElements);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
      showNotification("Error", "failed to fetch brand list", "error");
    } finally {
      setLoading(false);
    }
  };

  const onSearch = async (values, searchValue) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: "ASC",
        sortBy: "brandName",
        active: loginUserType === "Main Admin" ? 2 : 0,
      };
      const brandListingResponse = await BrandListingSearchService(
        requestBody,
        searchValue
      );

      if (brandListingResponse.statusCode === 6) {
        if (brandListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setBrandList(brandListingResponse.data.content);
        setTotalElements(brandListingResponse.data.totalElements);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    searchValue
  ) => {
    try {
      setLoading(true);
      const requestBody = {
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        sortDirection: sortValue === null ? "DESC" : sortValue,
        sortBy: orderBy,
        active: loginUserType === "Main Admin" ? 2 : 0,
        filterSearch :searchValue ? searchValue.trim() : null
      };
      // setTableLoader(true);
      const response = await BrandListingService(requestBody);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setBrandList([...brandList, ...response.data.content]);
        } else {
          setBrandList(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  const fetchCategoryList = async () => {
    try {
      const requestBody = {
        pageSize: 1000,
        pageNumber: 0,
        filterSearch: null,
        active: 0,
        sortDirection: "DESC",
        sortBy: "categoryName",
      };
      const categoryListingResponse = await categoryListingService(requestBody);

      if (categoryListingResponse.statusCode === 6) {
        setCategoryList(categoryListingResponse.data);
      } else {
        showNotification("Error", categoryListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchProductFamilyList = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 1000,
        filterSearch: null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        categoryId: id ? id : null,
        sortDirection: "DESC",
        sortBy: "productFamilyName",
      };
      const familyListingResponse = await FamilyListingService(obj);

      if (familyListingResponse.statusCode === 6) {
        setProductFamilyList(familyListingResponse.data);
      } else {
        showNotification("Error", familyListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchAllBrandsList = async () => {
    try {
      const allBrandsListingResponse = await AllBrandListingService();

      if (allBrandsListingResponse.statusCode === 6) {
        setAllBrands(allBrandsListingResponse.data);
      } else {
        showNotification("Error", allBrandsListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchBrickListWithorWithoutFamily = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 1000,
        filterSearch: null,   
        active: 0,
        productFamilyId: id ? id : 0,
        sortDirection: "DESC",
        sortBy: "brickName",
      };
      const brickListingResponse = await BrickListingWithOrWithoutFamilyId(obj);
      if (brickListingResponse.statusCode === 6) {
        setBrickList(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  return (
    <BrandList
      totalElements={totalElements}
      brandList={brandList}
      setBrandList={setBrandList}
      onSearch={onSearch}
      fetchBrandsDetails={fetchBrandsDetails}
      handleTableChanges={handleTableChanges}
      setLoading={setLoading}
      showNotification={showNotification}
      fetchCategoryList={fetchCategoryList}
      categoryList={categoryList}
      fetchBrickListWithorWithoutFamily={fetchBrickListWithorWithoutFamily}
      brickList={brickList}
      fetchProductFamilyList={fetchProductFamilyList}
      productFamilyList={productFamilyList}
      fetchAllBrandsList={fetchAllBrandsList}
      allBrands={allBrands}
      noRecord={noRecord}
    />
  );
};

export default Brand;
